import React from 'react';

import { ImageOptionsKey } from '@bingads-webui-campaign-react/smart-component-image';

import { LocalImagesSelect } from './local-images-select';

export const getImageOptionsConfig = ({
  onDefaultImageSelected,
  imageName,
  i18n,
}) => (
  {
    [ImageOptionsKey.DEFAULT]: {
      text: _TL_('Use image selected below'),
      onRenderBelowField: checked => (<LocalImagesSelect
        onSelected={onDefaultImageSelected}
        imageName={imageName}
        i18n={i18n}
        hidden={!checked}
      />),
    },
    [ImageOptionsKey.FACEBOOKIMPORT]: {
      text: _TL_('Use cover image from Facebook'),
    },
  }
);
